import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * delete recording and associated data
 */
export default async function deleteRecording(appointmentId: string | number) {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/transcription/appointment/${appointmentId}/recording`,
    {
      method: "DELETE",
    },
  );
  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(
      `failed to delete recording and associated data: ${getErrorDetail(
        responseText,
      )}`,
    );
  }
}
